// extracted by mini-css-extract-plugin
module.exports = {"input":"login_input-module--input--1oZ0h","password":"login_input-module--password--1fz5C"};